import { DrawerSection } from '@components/DrawerSection';
import { formatDate } from '@root/helpers';

interface DrawerLastUpdatedByProps {
  title: string;
  updatedAt: string;
  updatedByName: string;
}

export const DrawerLastUpdatedBy = ({ title, updatedAt, updatedByName }: DrawerLastUpdatedByProps) => (
  <DrawerSection title={title}>
    <div className="text-info-500 flex cursor-default items-start gap-1 text-sm">
      {`${formatDate(updatedAt, 'DD MMMM YYYY')}${` by ${updatedByName}`}`}
    </div>
  </DrawerSection>
);
